import { getStore } from '../store/store';

/**
 * Gets the value for the shouldEventsEndEarly cloud setting
 */
export default function getShouldEventsEndEarlyCloudSetting(): boolean | undefined {
    return getStore().shouldEventsEndEarly;
}
